import React, { useEffect, useState } from 'react';
import { Alert, Button, Spin } from 'antd';
import { useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import DonationV2Page from '../Donation/DonationV2/DonationV2Page';

export const getFridayAmount = (search) => {
  const params = new URLSearchParams(search);
  const donation = params.get('donation');
  const value = donation ?? params.get('amount');
  const amount = Number(String(value ?? '').replace(',', '.'));

  // `donation` also contains temporary input states after checkout opens.
  // Preserve amounts below the minimum while the donor is still typing; the
  // form validation is responsible for showing the minimum amount error.
  if (donation !== null) {
    return Number.isFinite(amount) && amount >= 0 ? amount.toFixed(2) : '0.00';
  }

  return Number.isFinite(amount) && amount >= 5 ? amount.toFixed(2) : '5.00';
};

export default function FreitagCheckout(props) {
  const [project, setProject] = useState(null);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    let active = true;
    setError(false);
    dispatch({ type: 'SAVE_KEY', payload: 4 });

    fetch('find_ramadan', {
      method: 'POST',
      body: JSON.stringify({ project_name: 'freitag' }),
    })
      .then((response) => {
        if (!response?.id) throw new Error('Friday project missing');
        if (active) {
          setProject({
            id: response.id,
            url: 'freitag',
            title: 'freitag',
            recurring_check: true,
          });
        }
      })
      .catch(() => {
        if (active) setError(true);
      });

    return () => {
      active = false;
    };
  }, [dispatch, attempt]);

  if (error) {
    return (
      <div style={{ padding: 32 }}>
        <Alert
          type="error"
          message="Die Freitagsspende konnte nicht geladen werden."
        />
        <Button onClick={() => setAttempt(attempt + 1)}>
          Erneut versuchen
        </Button>
      </div>
    );
  }

  if (!project)
    return (
      <div style={{ padding: 32, textAlign: 'center' }}>
        <Spin />
      </div>
    );

  const params = new URLSearchParams(props.location.search);
  const amount = getFridayAmount(props.location.search);
  if (params.get('donation') !== amount) {
    params.set('donation', amount);
    return (
      <Redirect to={{ ...props.location, search: `?${params.toString()}` }} />
    );
  }

  return (
    <DonationV2Page
      {...props}
      location={{ ...props.location, search: `?${params.toString()}` }}
      projectOverride={project}
    />
  );
}
